import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnChanges, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { MatOption } from '@angular/material/core';
@Component({
  selector: 'app-dropdown-rate',
  templateUrl: './dropdown-rate.component.html',
  styleUrls: ['./dropdown-rate.component.scss'],
  animations: [
    trigger('shrinkOut', [
      state('inactive', style({
        height: '0',
      })),
      state('active', style({
        zIndex: '101'
      })),
      transition('inactive => active', animate('300ms ease-in')),
      transition('active => inactive', animate('300ms ease-out'))
    ])
  ],
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class DropdownRateComponent implements OnInit, AfterViewInit {

  @Input() items: FilterItem[];
  @Input() selectedItems: string;
  @Input() alias: string;
  @Input() style: string;
  @Input() mat_select = false;
  @Output() update = new EventEmitter();

  @ViewChild('dropdown_title') dropdown_title: ElementRef;
  public searchQuery: string = '';
  public filteredItems: any[] = [];
  public isMobile;
  public isEmpty = true;
  public idPrefix = `dropdown_${guid(null)}_`;
  public controlState: 'active' | 'inactive' = 'inactive';
  public title: string;
  public selectItemsList: Array<string>;
  public enabledItems = [];
  @ViewChild('allSelected') private allSelected: MatOption;
  constructor() {
    this.isMobile = !window.matchMedia('only screen and (min-width: 768px)').matches;
  }

  onResize() {
    this.isMobile = !window.matchMedia('only screen and (min-width: 768px)').matches;
  }

  public ngOnInit() {
    this.filteredItems = [...this.items];
    if (this.selectedItems) {
      this.selectItemsList = this.selectedItems.split(',')
    }
    this.enabledItems = this.items
      .filter(i => this.selectItemsList.includes(i.id))
      .map(i => i.name);
    this.title = this.alias;
  }
  ngAfterViewInit() {
    // Инициализация состояния после отрисовки
    this.updateSelectionState();
  }
  filterItems() {
    if (!this.searchQuery) {
      this.filteredItems = [...this.items];
      return;
    }

    this.filteredItems = this.items.filter(item =>
      item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
  }

  public onClickOutside(event: any) {
    setTimeout(() => !event.isInside && (this.controlState = 'inactive'));
  }

  public changeState() {
    if (this.isMobile) return;
    this.controlState = (this.controlState === 'inactive') ? 'active' : 'inactive';
  }

  public onChecked() {
    this.onChange();
    this.update.emit();
  }

  public checkAll() {
    this.enabledItems = null;
    setTimeout(() => {
      if (this.allSelected) {
        this.allSelected.select();
      }
    });
    this.update.emit([]);
  }
  public clearAll() {
    this.enabledItems = null;
    setTimeout(() => {
      if (this.allSelected) {
        this.allSelected.select();
      }
    });
    this.update.emit([]);
  }
  private onChange() {
    const enabledItems = this.items
      .filter(item => item.isEnabled)
      .map(item => item.name);
    this.isEmpty = enabledItems.length === 0;
    this.title = enabledItems.join(', ') || this.alias;
  }

  public selectChange(selectedValues) {
    const filteredValues = selectedValues.filter(v => v !== '0');
    this.selectItemsList = this.items
      .filter(i => filteredValues.includes(i.name))
      .map(i => i.id);
    if (this.allSelected && this.allSelected.selected) {
      if (filteredValues.length > 0) {
        setTimeout(() => this.allSelected.deselect());
      }
    } else if (filteredValues.length == 0) {
      setTimeout(() => this.allSelected.select());
    }

    this.onChange();
    this.update.emit(this.selectItemsList);
  }

  private updateSelectionState() {
    setTimeout(() => {
      if (this.allSelected) {
        if (!this.enabledItems || this.enabledItems.length == 0) {
          this.allSelected.select();
        } else {
          this.allSelected.deselect();
        }
      }
    });
  }
}

export interface FilterItem {
  id: string;
  name: string;
  isEnabled: boolean;
}

export function guid(a: any): any {
  return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) :
    (1e7.toString(16) + -1e3 + -4e3 + -8e3 + -1e11)
      .replace(/[018]/g, guid)
      .replace(/-/g, '');
}
